import React from "react";

function Cards({ size = 50 }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="1.5"
      clipRule="evenodd"
      height={size}
      width={size}
      viewBox="0 0 100 100"
    >
      <path
        fill="#177DDC"
        stroke="#fff"
        strokeWidth="0.74"
        d="M92.26 10.91c0-2.079-2.739-3.767-6.112-3.767H12.705c-3.374 0-6.113 1.688-6.113 3.767v18.623c0 2.079 2.739 3.767 6.113 3.767h73.443c3.373 0 6.112-1.688 6.112-3.767V10.91z"
        transform="matrix(1 0 0 1.62275 .574 17.186)"
      ></path>
      <g>
        <path
          fill="#fff"
          fillRule="nonzero"
          d="M.259 0v-.631H.023v-.085h.568v.085H.354V0H.259z"
          transform="matrix(1.74008 0 0 .47068 -7.088 28.902) matrix(5.69017 0 0 21.0362 11.992 37.75)"
        ></path>
        <path
          fill="#fff"
          fillRule="nonzero"
          d="M.097 0v-.519h.088V0H.097zM.092-.583L.157-.72h.115l-.107.137H.092z"
          transform="matrix(1.74008 0 0 .47068 -7.088 28.902) matrix(5.69017 0 0 21.0362 15.468 37.75)"
        ></path>
        <path
          fill="#fff"
          fillRule="nonzero"
          d="M.258-.079l.013.078a.347.347 0 01-.067.008.149.149 0 01-.074-.015.084.084 0 01-.037-.04.32.32 0 01-.011-.104V-.45H.018v-.069h.064v-.128L.169-.7v.181h.089v.069H.169v.303a.15.15 0 00.005.048.031.031 0 00.015.017c.007.005.017.007.03.007.01 0 .023-.001.039-.004z"
          transform="matrix(1.74008 0 0 .47068 -7.088 28.902) matrix(5.69017 0 0 21.0362 17.049 37.75)"
        ></path>
        <path
          fill="#fff"
          fillRule="nonzero"
          d="M.406 0v-.076a.192.192 0 01-.165.088.203.203 0 01-.085-.018.142.142 0 01-.06-.044.202.202 0 01-.027-.065.518.518 0 01-.005-.082v-.322h.088v.288c0 .046.002.077.005.093a.092.092 0 00.035.054c.018.013.04.02.067.02a.15.15 0 00.074-.02.118.118 0 00.049-.055.274.274 0 00.014-.102v-.278h.088V0H.406z"
          transform="matrix(1.74008 0 0 .47068 -7.088 28.902) matrix(5.69017 0 0 21.0362 18.63 37.75)"
        ></path>
        <path
          fill="#fff"
          fillRule="nonzero"
          d="M0.064 -0.716H0.152V0H0.064z"
          transform="matrix(1.74008 0 0 .47068 -7.088 28.902) matrix(5.69017 0 0 21.0362 21.794 37.75)"
        ></path>
        <path
          fill="#fff"
          fillRule="nonzero"
          d="M.033-.259c0-.096.027-.167.08-.214A.244.244 0 01.276-.53a.23.23 0 01.175.07.267.267 0 01.068.193c0 .067-.01.12-.03.158a.213.213 0 01-.087.089.26.26 0 01-.126.032.236.236 0 01-.176-.07.283.283 0 01-.067-.201zm.091 0c0 .066.014.116.043.149a.138.138 0 00.109.049c.044 0 .08-.016.109-.049.029-.034.044-.084.044-.152 0-.064-.015-.113-.044-.146a.139.139 0 00-.109-.05.139.139 0 00-.109.05c-.029.033-.043.082-.043.149z"
          transform="matrix(1.74008 0 0 .47068 -7.088 28.902) matrix(5.69017 0 0 21.0362 23.059 37.75)"
        ></path>
      </g>
      <g>
        <path
          fill="#fff"
          fillOpacity="0.56"
          fillRule="nonzero"
          d="M.045-.23l.089-.008a.199.199 0 00.03.088.155.155 0 00.072.056.273.273 0 00.11.021.252.252 0 00.095-.016.129.129 0 00.062-.044.1.1 0 00.02-.061.093.093 0 00-.019-.059.141.141 0 00-.065-.042.937.937 0 00-.127-.035.644.644 0 01-.138-.045.196.196 0 01-.077-.067.168.168 0 01-.025-.089c0-.036.011-.07.031-.101a.198.198 0 01.09-.072.343.343 0 01.131-.024c.053 0 .1.009.141.026a.205.205 0 01.128.188l-.091.007A.143.143 0 00.453-.61C.425-.633.383-.645.328-.645c-.057 0-.099.011-.125.032a.094.094 0 00-.039.076.08.08 0 00.027.063.37.37 0 00.143.051c.077.018.13.033.159.046a.223.223 0 01.092.073c.02.03.03.063.03.102a.196.196 0 01-.033.108.221.221 0 01-.094.078.41.41 0 01-.301 0 .227.227 0 01-.103-.085.239.239 0 01-.039-.129z"
          transform="matrix(1.74008 0 0 .47068 -7.088 42.23) matrix(4.07069 0 0 15.0491 11.992 33.46)"
        ></path>
        <path
          fill="#fff"
          fillOpacity="0.56"
          fillRule="nonzero"
          d="M.406 0v-.076a.192.192 0 01-.165.088.203.203 0 01-.085-.018.142.142 0 01-.06-.044.202.202 0 01-.027-.065.518.518 0 01-.005-.082v-.322h.088v.288c0 .046.002.077.005.093a.092.092 0 00.035.054c.018.013.04.02.067.02a.15.15 0 00.074-.02.118.118 0 00.049-.055.274.274 0 00.014-.102v-.278h.088V0H.406z"
          transform="matrix(1.74008 0 0 .47068 -7.088 42.23) matrix(4.07069 0 0 15.0491 14.707 33.46)"
        ></path>
        <path
          fill="#fff"
          fillOpacity="0.56"
          fillRule="nonzero"
          d="M.147 0H.065v-.716h.088v.256a.173.173 0 01.142-.07c.032 0 .063.006.091.019a.188.188 0 01.07.054.268.268 0 01.044.084c.01.033.015.068.015.106a.296.296 0 01-.066.206.207.207 0 01-.158.073.166.166 0 01-.144-.077V0zM.146-.263c0 .062.008.107.025.135.028.045.065.067.113.067a.124.124 0 00.099-.05C.411-.144.425-.194.425-.26c0-.067-.013-.117-.04-.15a.123.123 0 00-.097-.048.127.127 0 00-.1.05C.16-.375.146-.326.146-.263z"
          transform="matrix(1.74008 0 0 .47068 -7.088 42.23) matrix(4.07069 0 0 15.0491 16.971 33.46)"
        ></path>
        <path
          fill="#fff"
          fillOpacity="0.56"
          fillRule="nonzero"
          d="M.258-.079l.013.078a.347.347 0 01-.067.008.149.149 0 01-.074-.015.084.084 0 01-.037-.04.32.32 0 01-.011-.104V-.45H.018v-.069h.064v-.128L.169-.7v.181h.089v.069H.169v.303a.15.15 0 00.005.048.031.031 0 00.015.017c.007.005.017.007.03.007.01 0 .023-.001.039-.004z"
          transform="matrix(1.74008 0 0 .47068 -7.088 42.23) matrix(4.07069 0 0 15.0491 19.235 33.46)"
        ></path>
        <path
          fill="#fff"
          fillOpacity="0.56"
          fillRule="nonzero"
          d="M.097 0v-.519h.088V0H.097zM.092-.583L.157-.72h.115l-.107.137H.092z"
          transform="matrix(1.74008 0 0 .47068 -7.088 42.23) matrix(4.07069 0 0 15.0491 20.366 33.46)"
        ></path>
        <path
          fill="#fff"
          fillOpacity="0.56"
          fillRule="nonzero"
          d="M.258-.079l.013.078a.347.347 0 01-.067.008.149.149 0 01-.074-.015.084.084 0 01-.037-.04.32.32 0 01-.011-.104V-.45H.018v-.069h.064v-.128L.169-.7v.181h.089v.069H.169v.303a.15.15 0 00.005.048.031.031 0 00.015.017c.007.005.017.007.03.007.01 0 .023-.001.039-.004z"
          transform="matrix(1.74008 0 0 .47068 -7.088 42.23) matrix(4.07069 0 0 15.0491 21.497 33.46)"
        ></path>
        <path
          fill="#fff"
          fillOpacity="0.56"
          fillRule="nonzero"
          d="M.406 0v-.076a.192.192 0 01-.165.088.203.203 0 01-.085-.018.142.142 0 01-.06-.044.202.202 0 01-.027-.065.518.518 0 01-.005-.082v-.322h.088v.288c0 .046.002.077.005.093a.092.092 0 00.035.054c.018.013.04.02.067.02a.15.15 0 00.074-.02.118.118 0 00.049-.055.274.274 0 00.014-.102v-.278h.088V0H.406z"
          transform="matrix(1.74008 0 0 .47068 -7.088 42.23) matrix(4.07069 0 0 15.0491 22.628 33.46)"
        ></path>
        <path
          fill="#fff"
          fillOpacity="0.56"
          fillRule="nonzero"
          d="M0.064 -0.716H0.152V0H0.064z"
          transform="matrix(1.74008 0 0 .47068 -7.088 42.23) matrix(4.07069 0 0 15.0491 24.892 33.46)"
        ></path>
        <path
          fill="#fff"
          fillOpacity="0.56"
          fillRule="nonzero"
          d="M.033-.259c0-.096.027-.167.08-.214A.244.244 0 01.276-.53a.23.23 0 01.175.07.267.267 0 01.068.193c0 .067-.01.12-.03.158a.213.213 0 01-.087.089.26.26 0 01-.126.032.236.236 0 01-.176-.07.283.283 0 01-.067-.201zm.091 0c0 .066.014.116.043.149a.138.138 0 00.109.049c.044 0 .08-.016.109-.049.029-.034.044-.084.044-.152 0-.064-.015-.113-.044-.146a.139.139 0 00-.109-.05.139.139 0 00-.109.05c-.029.033-.043.082-.043.149z"
          transform="matrix(1.74008 0 0 .47068 -7.088 42.23) matrix(4.07069 0 0 15.0491 25.796 33.46)"
        ></path>
      </g>
    </svg>
  );
}

export default React.memo(Cards);
